module.exports = __webpack_public_path__ + "static/media/Nov2-F18.2cad55ef.png";